document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll(
    'product-list-with-details[data-hoverable="true"]'
  );

  sections.forEach((section) => {
    const cards = Array.from(
      section.querySelectorAll('.col-product-card')
    );

    if (cards.length < 2) return;

    let currentIndex = 0;
    let timer = null;
    let userHovering = false;
    let automaticChange = false;

    const activateCard = (index) => {
      const card = cards[index];
      if (!card) return;

      automaticChange = true;

      card.dispatchEvent(
        new MouseEvent('mouseenter', {
          bubbles: false,
          cancelable: true,
          view: window
        })
      );

      automaticChange = false;
    };

    cards.forEach((card, index) => {
      card.addEventListener('mouseenter', () => {
        currentIndex = index;

        if (!automaticChange) {
          userHovering = true;
        }
      });

      card.addEventListener('mouseleave', () => {
        userHovering = false;
      });
    });

    timer = setInterval(() => {
      if (userHovering) return;

      currentIndex = (currentIndex + 1) % cards.length;
      activateCard(currentIndex);
    }, 4000);
  });
});